import React, { useState } from "react";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import Layout from "../../../HOC/layout/Layout";
import AddService from "../../PageComponent/ServiceData/AddService/AddService";
import ViewService from "../../PageComponent/ServiceData/ViewService/ViewService";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";
function Service() {
  const [showData, setShowData] = useState("Add");
  const SearchText = () => {
    console.log(4);
  };
  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            addBtn="AddService"
            viewBtn="ViewService"
            SearchText={SearchText}
          />
          {showData === "Add" ? <AddService /> : <ViewService />}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Service;
